import { useMemo } from "react"
import { useNoosSupplyPlanDetailContext } from "~/context/NoosSupplyPlanDetailProvider"
import { useGetCollections } from "~/hooks/useCollections"

/** Unique variant ids across the open NOOS supply plan's collections. */
export function useNoosPlanVariantIds(): { variantIds: string[]; isLoading: boolean } {
  const { supplyPlan } = useNoosSupplyPlanDetailContext()
  const collectionIds = useMemo(
    () => supplyPlan.collectionIds.map(Number),
    [supplyPlan.collectionIds],
  )
  const { data: collections, isLoading } = useGetCollections({
    collectionIds,
    allowNoCollections: true,
  })
  const variantIds = useMemo(
    () => [...new Set(collections.flatMap((c) => c.variantIds))],
    [collections],
  )
  return { variantIds, isLoading }
}
